<h3 mat-dialog-title>Verify using your emailId</h3>
<div mat-dialog-content class="md-padding">
  <p>Enter the pin received on email:</p>

  <nb-form-field>
    <input [type]="getInputType()" nbInput [(ngModel)]="userOtp" minlength="6" maxlength="6">
    <button nbSuffix nbButton ghost (click)="toggleShowPassword()">
      <nb-icon [icon]="showPassword ? 'eye-outline' : 'eye-off-2-outline'" pack="eva"
      [attr.aria-label]="showPassword ? 'hide password' : 'show password'">
    </nb-icon>
  </button>
</nb-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="sendEmail()">Send Email</button>
  <button mat-button (click)="onNoClick()">No Thanks</button>
  <button mat-button (click)="verifyOtpReceived()">Ok</button>
</div>
